import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { CheckboxCellRendererParams } from '@ddv/data-grid';
import {
    EDITABLE_CHECKBOX_FIELD,
    TFL_DETAILS_AUTO_GROUP_COLUMN_ID,
    TRANSACTION_TYPE_FIELD,
    isTradeFileDetails,
    QueryTypeName,
} from '@ddv/models';

import { breakEventStatus } from '../../models/middle-office';

@Component({
    selector: 'app-checkbox-cell-renderer',
    templateUrl: './checkbox-cell-renderer.component.html',
    styleUrls: ['./checkbox-cell-renderer.component.scss'],
    standalone: false,
})
export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
    // value can be undefined for a group where not all children are selected
    value: boolean | undefined = false;
    showCheckbox = false;
    protected disabled = false;
    private params: CheckboxCellRendererParams | undefined;
    private isBlock = false;

    agInit(params: CheckboxCellRendererParams): void {
        this.params = params;
        const { api, node, queryTypeName } = params;

        if (this.isQueryTypeSettlementBreaks()) {
            this.setCheckboxState();
        } else {
            this.value = node.isSelected();
        }

        let isAllocation = false;
        if (isTradeFileDetails(queryTypeName)) {
            const rowGroupColumns = api.getRowGroupColumns();
            const gridGroupedByAllocationGroupId = rowGroupColumns.length === 1 &&
                rowGroupColumns[0].getColDef().field === TFL_DETAILS_AUTO_GROUP_COLUMN_ID;
            isAllocation = gridGroupedByAllocationGroupId &&
                node.data?.[TFL_DETAILS_AUTO_GROUP_COLUMN_ID] && !node.data[TRANSACTION_TYPE_FIELD];
            this.isBlock = gridGroupedByAllocationGroupId &&
                node.data?.[TFL_DETAILS_AUTO_GROUP_COLUMN_ID] && node.data[TRANSACTION_TYPE_FIELD];
        }
        this.showCheckbox = !node.group && !isAllocation;
    }

    refresh(params: CheckboxCellRendererParams): boolean {
        this.params = params;

        if (this.isQueryTypeSettlementBreaks()) {
            this.setCheckboxState();
        }

        this.value = !!this.params?.node.isSelected() && !this.disabled;
        this.params?.setValue?.(this.value);
        this.params?.node.setSelected(this.value);
        this.params.node.selectable = !this.disabled;

        return true;
    }

    onClick(value: boolean): void {
        if (this.isBlock) {
            this.params?.node.parent?.allLeafChildren?.forEach((childNode) => {
                // this seems really bad smashing our own stuff back onto ag-grid objects
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (childNode as any)[EDITABLE_CHECKBOX_FIELD] = value;
                childNode.setSelected(value);
            });
        } else {
            this.params?.setValue?.(value);
            this.params?.node.setSelected(value);
        }
        this.params?.api.refreshHeader();
    }

    private setCheckboxState(): void {
        this.disabled = this.params?.data?.[breakEventStatus] !== 'Created' || !this.params.data.Trade_Release_Comment;
    }

    private isQueryTypeSettlementBreaks(): boolean {
        return this.params?.queryTypeName === QueryTypeName.SETTLEMENT_BREAKS;
    }
}
